import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API, SESSION_TOKEN_KEY } from "../App";
import { resolveHomePath } from "../utils/roleRedirect";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error("No session_id found in URL");
        navigate("/", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: {
              "X-Session-ID": sessionId
            },
            withCredentials: true
          }
        );

        // CRITICAL: Store session token in localStorage FIRST before any redirect
        // This is essential for the fallback mechanism when cookies don't work
        const token = response.data.session_token;
        if (token) {
          try {
            localStorage.setItem(SESSION_TOKEN_KEY, token);
            console.log('[Auth] Session token stored in localStorage:', token.substring(0, 10) + '...');
          } catch (e) {
            console.warn('[Auth] Could not store session token in localStorage:', e);
          }
        } else {
          console.warn('[Auth] No session_token in response');
        }

        // Login successful - update auth state
        login(response.data);

        // Redirect based on role
        const redirectPath = resolveHomePath(response.data);

        // Use window.location for reliable redirect after OAuth
        // The token is already saved in localStorage, so checkAuth will find it
        window.location.href = window.location.origin + redirectPath;
      } catch (error) {
        console.error("Auth exchange failed:", error);
        // 403 = account not allowed on this domain; show why on the landing page
        if (error.response?.status === 403 && error.response?.data?.detail) {
          try {
            sessionStorage.setItem("login_error", error.response.data.detail);
          } catch (storageError) {
            // sessionStorage not available, ignore
          }
        }
        // Clear any stale tokens
        try {
          localStorage.removeItem(SESSION_TOKEN_KEY);
        } catch (storageError) {
          // localStorage not available, ignore
        }
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-cockpit-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <h2 className="font-chivo text-xl text-cockpit-text-bright mb-2">A autenticar...</h2>
        <p className="text-slate-400 font-mono text-sm">Por favor aguarde</p>
      </div>
    </div>
  );
};

export default AuthCallback;
